import { useDetailApi } from "../../../swr/useApi";
import { adminProductRequestsService } from "../../api_client";
import type { ProductRequestDto } from "../../../api";

export function useAdminProductRequestDetails(id?: string | null) {
    return useDetailApi<ProductRequestDto>({
        key: id ? `admin-product-request-details-${id}` : null,
        serviceMethod: async () => await adminProductRequestsService.adminGetProductRequestById(id ?? ""),
    });
}

